import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=04fb1f48"
import script from "./Drawer.js?vue&type=script&lang=js&external"
export * from "./Drawer.js?vue&type=script&lang=js&external"
import style0 from "./Drawer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports